import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const FIELDS = [['name', 'Office name', true], ['address', 'Street address'], ['city', 'City'], ['state', 'State'], ['zip', 'ZIP'], ['phone', 'Office phone'], ['email', 'Office email']];

export const OfficeForm = ({ initial = {}, onSave, onCancel, saveLabel = 'Save office', testId = 'office-form' }) => {
  const [f, setF] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, initial[k] || ''])));
  const [saving, setSaving] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await onSave(f); } finally { setSaving(false); }
  };
  return (
    <form onSubmit={submit} className="grid gap-3 sm:grid-cols-2" data-testid={testId}>
      {FIELDS.map(([k, label, req]) => (
        <label key={k} className={`text-sm font-medium text-gray-700 grid gap-1 ${k === 'name' || k === 'address' ? 'sm:col-span-2' : ''}`}>
          {label}{req ? ' *' : ''}
          <Input required={req} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`${testId}-${k}`} />
        </label>
      ))}
      <div className="sm:col-span-2 flex gap-2">
        <Button type="submit" disabled={saving} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid={`${testId}-save`}>{saving ? 'Saving...' : saveLabel}</Button>
        {onCancel && <Button type="button" variant="outline" onClick={onCancel} data-testid={`${testId}-cancel`}>Cancel</Button>}
      </div>
    </form>
  );
};
